<template>
  <div>
    <label
      v-if="label"
      class="label"
    >
      {{ label }}
    </label>

    <md-list class="list">
      <md-list-item
        v-for="(entry, index) in entries"
        :key="entry[0]"
      >
        <div class="fields-wrapper">
          <md-field class="key-field">
            <label>key</label>
            <md-input
              v-model="entry[0]"
            />
          </md-field>

          <md-field>
            <label>Value</label>
            <md-input
              v-model="entry[1]"
            />
          </md-field>
        </div>

        <md-icon
          @click.native="removeEntry(index)"
        >
          clear
        </md-icon>
      </md-list-item>

      <md-button
        class="add-entry-button md-icon-button md-raised md-primary"
        style="margin: 5px auto;"
      >
        <md-icon @click.native="addEntry">
          add
        </md-icon>
      </md-button>
    </md-list>
  </div>
</template>
<script>
    export default {
        name: "StringToStringMapInput",
        props: {
            value: { type: Object, required: true, default: () => ({}) },
            label: { type: String, required: false, default: ""}
        },
        data() {
            return {
                entries: Object.keys(this.$props.value).length === 0
                    ? [["", ""]]
                    : Object.entries(this.$props.value),
            };
        },
        watch: {
            entries() {
                this.onUpdate();
            }
        },
        methods: {
            addEntry() {
                this.entries.push(["",""]);
            },
            removeEntry(index) {
                this.entries.splice(index, 1);
            },
            onUpdate() {
                const returnValue = this.entries.filter(([k, v]) => (k.length > 0) && (v.length > 0));
                this.$emit("update:value", Object.fromEntries(returnValue));
            },
            deleteBenefit() {
                this.$emit("delete-benefit");
            },
        }
    };
</script>
<style lang="scss" scoped>
  .fields-wrapper {
    display: flex;
    column-gap: 12px;

    .key-field {
      max-width: 120px;
    }
  }

  .list {
    padding: 0;
  }
</style>
